/*eslint-disable*/
import { Box, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import SidebarContent from "./SidebarContent";

function Sidebar(props) {
  const mainPanel = React.useRef();
  let variantChange = "0.25s cubic-bezier(0.4, 0, 0.2, 1)";

  const { logoText, routes, sidebarVariant } = props;

  const sidebarBg = useColorModeValue(
    "rgba(255, 255, 255, 0.85)",
    "rgba(11, 19, 41, 0.85)"
  );
  const sidebarBorder = useColorModeValue(
    "1px solid rgba(226, 232, 240, 0.8)",
    "1px solid rgba(255, 255, 255, 0.08)"
  );
  const sidebarShadow = useColorModeValue(
    "0 20px 40px rgba(15, 23, 42, 0.08)",
    "0 20px 40px rgba(0, 0, 0, 0.4)"
  );

  return (
    <Box ref={mainPanel}>
      <Box display={{ sm: "none", xl: "block" }} position="fixed">
        <Box
          css={{
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "transparent",
              borderRadius: "10px",
              transition: "background 0.3s ease",
            },
            "&:hover::-webkit-scrollbar-thumb": {
              background: "rgba(13, 148, 136, 0.4)",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#0d9488",
            },
            scrollbarWidth: "thin",
            scrollbarColor: "transparent transparent",
            "&:hover": {
              scrollbarColor: "rgba(13, 148, 136, 0.4) transparent",
            },
          }}
          bg={sidebarBg}
          backdropFilter="blur(20px)"
          border={sidebarBorder}
          boxShadow={sidebarShadow}
          transition={variantChange}
          w="265px"
          maxW="265px"
          ms="16px"
          my="16px"
          h="calc(100vh - 32px)"
          px="16px"
          borderRadius="24px"
          overflowY="auto"
        >
          <SidebarContent 
            routes={routes}
            logoText={logoText}
            display="none"
            sidebarVariant={sidebarVariant}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default Sidebar;

